export default __webpack_public_path__ + "static/main-logo-885addcf5c288c712ae692a2d546b09d.png";